/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'screen_time': {
    width: 16,
    height: 16,
    viewBox: '0 0 54.83 54.83',
    data: '<g data-name="图层 2"><g data-name="图层 1" _fill="none" _stroke="#c4c4c4" stroke-linecap="round" stroke-width="2"><path pid="0" d="M31.87 53.45a26.38 26.38 0 1121-19M27.41 10.49v16.92h13.42" stroke-miterlimit="10"/><path pid="1" stroke-linejoin="round" d="M38.14 50.1l4.47-7.16 4.26 5.16 6.18-8.16"/></g></g>'
  }
})
